export async function fetchMe() {
  const res = await fetch('/api/auth/me', { credentials: 'include' })
  if (!res.ok) return null
  return res.json()
}

export async function refresh() {
  const res = await fetch('/api/auth/refresh', {
    method: 'POST',
    credentials: 'include'
  })
  return res.ok
}

export async function requireAuth() {
  let me = await fetchMe()
  if (me) return me

  // access 만료 → refresh 시도
  const ok = await refresh()
  if (!ok) return null

  me = await fetchMe()
  return me
}

export async function logout() {
  await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' })
}
